var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy",domProps:{"innerHTML":_vm._s(_vm.getMarkdown())}})
}
var staticRenderFns = []

export { render, staticRenderFns }